import { createFormContext } from "@mantine/form"
import type { Crossbar } from "crossbar/types/crossbar.model"

export const [
  CrossbarFormProvider,
  useCrossbarFormContext,
  useCrossbarForm,
] = createFormContext<Omit<Crossbar, "id">>()
